import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { EventDetails } from '../../../shared/models/event';
import { Observable, BehaviorSubject } from 'rxjs';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { activity, IroleProcessActivity } from 'src/app/shared/models/activity';
import { GetAllActivities } from 'src/app/shared/models/getallactivities';
// import { Reason } from 'src/app/shared/models/createschedule';
import { RescheduleReason } from 'src/app/shared/models/reschedulereasons';
import {
  CandidateBasicDetails,
  CandidateListReqBody,
  SchedulerCandidate,
  CorrespondenceReqBody,
  ScheduleStatsReqBody,
  RejectionReqBody,
  ActivitiesOnCandidate,
  CandidateMapping,
} from 'src/app/shared/models/schedulerAssociate';
import { ScheduleStatsTable } from 'src/app/shared/models/schedulerAdmin';
// import { Status } from 'src/app/shared/models/operations_persona';
import { environment } from 'src/environments/environment.prod';
import { RoleService } from 'src/app/core/services/role.service';
import { process } from 'src/app/shared/models/process';
@Injectable({
  providedIn: 'root',
})
export class AssociateService {
  id = parseInt(localStorage.getItem('fresherCompHiringTypeId'));
  eventUrl: string = environment.eventUrl;
  scheduleStatsUrl: string = environment.dashboardUrl;
  activityUrl: string = environment.activityUrl;
  schedulerDashboardUrl: string = environment.schedulerDashboardUrl;
  activityCardsUrl: string = environment.eventCandidateDataUrl;
  recruiterGenUrl: string = environment.recruiterGenUrl;

  private options = { headers: new HttpHeaders().set('Content-Type', 'application/json') };
  private textOptions = {
    headers: new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8'),
    responseType: 'text' as 'json',
  };
  processId: number;
  private selectedEvent = new BehaviorSubject<any>(undefined);
  private selectedCandidate = new BehaviorSubject<any>(undefined);
  private selectedStatus = new BehaviorSubject<any>(undefined);
  private recruiterActivity$ = new BehaviorSubject(null);
  recruiterActivity = this.recruiterActivity$.asObservable();

  constructor(
    private http: HttpClient,
    private roleService: RoleService,
  ) {}
  getJobDescription(reqId) {
    return this.http.get<any>(this.recruiterGenUrl + 'getPosting/' + reqId);
  }
  getEventDetails(employeeNo?: string): Observable<EventDetails[]> {
    return this.http.get<EventDetails[]>(this.eventUrl + 'events/getEventsByEmpno?employeeNo=' + employeeNo);
  }
  getScheduleStatsByEventEmployee(reqBody: ScheduleStatsReqBody): Observable<ScheduleStatsTable[]> {
    return this.http.post<ScheduleStatsTable[]>(
      this.scheduleStatsUrl + 'DashboardServices/getScheduleStatsByEventEmployee',
      reqBody,
    );
  }

  getProcessActivities(roleCode): Observable<any> {
    const options = { headers: new HttpHeaders().set('Content-Type', 'application/json') };
    const body = {
      roleCode: roleCode,
      companyHiringTypeId: this.id,
      appCode: 'InTap',
      isLoginUser: 'yes',
    };
    return this.http.post<IroleProcessActivity[]>(
      this.activityUrl + 'activity/getRolesActivitiesProcesses',
      body,
      options,
    );
  }

  getProcess(): Observable<process[]> {
    return this.http.get<process[]>('assets/json/process.json');
  }

  getActivities(processId?: number): Observable<activity[]> {
    return this.http.get<activity[]>(
      this.activityUrl + 'activity/getActivities?processId=' + processId + '&companyHiringTypeId=' + this.id,
    );
  }
  getAllActivities(): Observable<GetAllActivities[]> {
    return this.http.get<GetAllActivities[]>('assets/json/getallactivities.json');
  }

  getRescheduleReasons(): Observable<RescheduleReason[]> {
    return this.http.get<RescheduleReason[]>('assets/json/reschedulereasons.json');
  }

  getCandidateBasicDetails(applicationId: any, candidateId: any): Observable<CandidateBasicDetails> {
    return this.http.get<CandidateBasicDetails>(
      this.schedulerDashboardUrl +
        'candidate/getBasicCandidateDetails?candidateId=' +
        candidateId +
        '&applicationId=' +
        applicationId,
    );
  }
  getCandidateListByIds(applicationIds?: CandidateListReqBody): Observable<SchedulerCandidate[]> {
    return this.http.post<SchedulerCandidate[]>(
      this.schedulerDashboardUrl + 'candidate/getAllCandidates',
      applicationIds,
    );
  }

  //Activity list for candidate
  getActivitiesOnCandidate(applicationId: any, candidateId: any): Observable<ActivitiesOnCandidate> {
    return this.http.get<ActivitiesOnCandidate>(
      this.activityCardsUrl + 'getCandidateActivities?applicationId=' + applicationId + '&candidateId=' + candidateId,
    );
  }

  // Correspondence services
  getStatus(): Observable<object> {
    return this.http.get<object>(this.activityUrl + 'activity/getStatus');
  }
  getApplicantsActivity(applicationId: number, activityID: number, processId: number) {
    return this.http.get(
      this.activityUrl +
        'activity/isApplicantsActivityAvailable?applicationId=' +
        applicationId +
        '&processID=' +
        processId +
        '&activityID=' +
        activityID,
    );
  }
  getCorrespondenceActivityById(applicationId: any, activityId: any, processId: number): Observable<any> {
    return this.http.get<any>(
      this.activityUrl +
        'activity/getCorrespondenceActivityById?applicationId=' +
        applicationId +
        '&processID=' +
        processId +
        '&activityID=' +
        activityId +
        '&companyHiringTypeID=' +
        this.id,
      this.options,
    );
  }
  saveCorrespondenceActivity(correspondenceReqBody: CorrespondenceReqBody): Observable<any> {
    const requestOptions: object = {
      responseType: 'text',
      headers: new HttpHeaders().set('Content-Type', 'application/json'),
    };
    return this.http.post<any>(
      this.activityUrl + 'activity/saveCorrespondenceActivity?hiringTypeID=' + this.id,
      correspondenceReqBody,
      requestOptions,
    );
  }
  editCorrespondenceActivity(correspondenceReqBody: CorrespondenceReqBody): Observable<any> {
    const requestOptions: object = {
      headers: new HttpHeaders().set('Content-Type', 'application/json'),
    };
    return this.http.post<any>(
      this.activityUrl + 'activity/editCorrespondenceActivity',
      correspondenceReqBody,
      requestOptions,
    );
  }

  //rejection services
  getReasons(): Observable<object> {
    return this.http.get<object>(this.activityUrl + 'activity/getAllReasons?companyHiringTypeId=' + this.id);
  }
  getAppStatusChangeById(applicationId: any, activityId: any, processId: number): Observable<any> {
    return this.http.get<any>(
      this.activityUrl +
        'activity/getAppStatusChangeById?applicationId=' +
        applicationId +
        '&processID=' +
        processId +
        '&activityID=' +
        activityId +
        '&hiringTypeID=' +
        this.id,
    );
  }
  saveAppStatusChange(rejectionReqBody?: RejectionReqBody): Observable<any> {
    const requestOptions: object = {
      responseType: 'text',
      headers: new HttpHeaders().set('Content-Type', 'application/json'),
    };
    return this.http.post<any>(this.activityUrl + 'activity/saveAppStatusChange', rejectionReqBody, requestOptions);
  }
  editAppStatusChange(rejectionReqBody?: RejectionReqBody): Observable<any> {
    return this.http.post<any>(this.activityUrl + 'activity/editAppStatusChange', rejectionReqBody);
  }
  updateEventCandidateMapping(reqBody: CandidateMapping) {
    return this.http.post<any>(this.activityUrl + 'activity/updateEventCandidateMapping', reqBody, this.textOptions);
  }

  // get getEventStatusDetails
  getEventStatusDetails() {
    return this.http.get<any>(this.activityUrl + 'EventStatus/getEventStatusDetails');
  }

  // behavior subject to get required data for chnaging status call
  setSelectedEvent(event) {
    this.selectedEvent.next(event);
  }
  setSelectedCandidate(candidate) {
    this.selectedCandidate.next(candidate);
  }
  setSelectedStatus(statusID) {
    this.selectedStatus.next(statusID);
  }

  getSelectedEvent() {
    return this.selectedEvent;
  }
  getSelectedCandidate() {
    return this.selectedCandidate;
  }
  getSelectedStatus() {
    return this.selectedStatus;
  }

  // put updateEventStatus
  putUpdateEventStatus(updateStatusBodyOBJ) {
    // console.log('venkat', updateStatusBodyOBJ);
    return this.http.post<any>(this.schedulerDashboardUrl + 'EventStatus/updateEventStatus', updateStatusBodyOBJ);
  }
}

@Injectable({
  providedIn: 'root',
})
export class AssociateResolverService {
  constructor(private associateApi: AssociateService) {}
  resolve(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot) {
    return this.associateApi.getEventDetails();
  }
}
